export const generateYearsList = (startYear: number, endYear: number) => {
  var list: Array<number> = [];
  for (let i = startYear; i >= endYear; i--) {
    list.push(i);
  }
  return list;
};
